export const EXPERT_PARTNER_AGENTS = [
    { label: 'Leo', value: 'leo' },
    { label: 'Claire', value: 'claire' },
    { label: 'Rebecca', value: 'rebecca' },
    { label: 'Charles', value: 'charles' },
    { label: 'Sofia', value: 'sofia' },
    { label: 'Filipa', value: 'filipa' },
    { label: 'Iris', value: 'iris' },
    { label: 'Martin', value: 'martin' },
];

export const EXPERT_PARTNER_COLORS_PALETTE = [
    '#D9F99D',
    '#86EFAC',
    '#67E8F9',
    '#93C5FD',
    '#C4B5FD',
    '#FDBA74',
    '#FCA5A5',
    '#F9A8D4',
    '#E5E7EB',
    '#111827',
];

export const getExpertPartnerAgentLabel = (value?: string) => {
    if (!value) return '--';
    return EXPERT_PARTNER_AGENTS.find((item) => item.value === value)?.label || value;
};
